import { type SupportTransport, useSupportRequest } from '../hooks/useSupportRequest';
import type { SupportInteraction, SupportRequest as SupportRequestCreate } from '../types';

import { type JotSupportDisplayProps, JotSupportWidget } from './JotSupportWidget';

/** Controller and presentation with injected transport; no Auth0 or store import. */
export function JotSupportFlow({
  transport,
  replyEmail,
  pageArea = 'other',
  initiallyOpen = false,
  reducedMotion = false,
  onInteraction,
  ...display
}: JotSupportDisplayProps & {
  transport: SupportTransport;
  replyEmail: string;
  pageArea?: SupportRequestCreate['page_area'];
  initiallyOpen?: boolean;
  reducedMotion?: boolean;
  onInteraction?: (event: SupportInteraction) => void;
}) {
  const support = useSupportRequest(transport, replyEmail, pageArea);
  return (
    <JotSupportWidget
      {...display}
      draft={support.draft}
      onDraftChange={support.setDraft}
      view={support.view}
      replyEmail={support.replyEmail}
      onSubmit={() => void support.submit()}
      onRetry={() => void support.retry()}
      onCheckStatus={() => void support.checkStatus()}
      checkingStatus={support.checkingStatus}
      onNewRequest={support.newRequest}
      preparationError={support.preparationError}
      initiallyOpen={initiallyOpen}
      reducedMotion={reducedMotion}
      onInteraction={onInteraction}
    />
  );
}
